import React from 'react'

const ContainerBox = (props) => {
    const { clase, children } = props;
    return (
        <div className={`flex flex-col gap-5 p-5 bg-white rounded-md shadow-nav ${clase} w-full`}>
            { children }
        </div>
    )
}

export default ContainerBox